import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from './locales/en.json';
import ku from './locales/ku.json';
import ar from './locales/ar.json';

import dealerEn from './locales/dealer/en.json';
import dealerAr from './locales/dealer/ar.json';
import dealerKu from './locales/dealer/ku.json';

const resources = {
  en: { translation: en, dealer: dealerEn },
  ku: { translation: ku, dealer: dealerKu },
  ar: { translation: ar, dealer: dealerAr },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    supportedLngs: ['en', 'ku', 'ar'],
    ns: ['translation', 'dealer'],
    defaultNS: 'translation',
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
    },
  });

// Set document direction based on language
i18n.on('languageChanged', (lng) => {
  const dir = lng === 'ar' || lng === 'ku' ? 'rtl' : 'ltr';
  document.documentElement.dir = dir;
  document.documentElement.lang = lng;
});

export default i18n;
